export default __webpack_public_path__ + "static/media/1.0f9ddae4.jpg";